import { type RefObject, useRef } from 'react';

import type { SwimlaneApi } from './types';

export const useSwimlaneApiRef = () =>
  useRef<SwimlaneApi | undefined>(undefined) as RefObject<SwimlaneApi>;
